import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bills from './pages/Bills';
import BillDetail from './pages/BillDetail';
import Customers from './pages/Customers';
import Payments from './pages/Payments';
import Reconciliation from './pages/Reconciliation';
import Reports from './pages/Reports';
import Configuration from './pages/Configuration';
import AuditLog from './pages/AuditLog';
import Users from './pages/Users';
import NotFound from './pages/NotFound';
import BillNew from './pages/BillNew';
import ApiClients from "./pages/ApiClients";
import BillEdit from './pages/BillEdit';
import CustomerNew from './pages/CustomerNew';
import CustomerEdit from './pages/CustomerEdit';
import BillView from './pages/BillView';

function PrivateRoute({ children, requiredRoles = [] }) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0 && !requiredRoles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <ToastContainer position="top-right" autoClose={5000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/bills/view/:token" element={<BillView />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="bills" element={<Bills />} />
          <Route path="bills/new" element={<BillNew />} />
          <Route path="bills/:id/edit" element={<BillEdit />} />
          <Route path="bills/:id" element={<BillDetail />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/new" element={<CustomerNew />} />
          <Route path="customers/:id/edit" element={<CustomerEdit />} />
          <Route path="payments" element={<Payments />} />
<Route path="api-clients" element={<PrivateRoute requiredRoles={["admin", "system_admin"]}><ApiClients /></PrivateRoute>} />
          <Route path="reconciliation" element={<Reconciliation />} />
          <Route path="reports" element={<Reports />} />
          <Route path="configuration" element={<PrivateRoute requiredRoles={['admin', 'system_admin']}><Configuration /></PrivateRoute>} />
          <Route path="audit-log" element={<PrivateRoute requiredRoles={['admin', 'auditor']}><AuditLog /></PrivateRoute>} />
          <Route path="users" element={<PrivateRoute requiredRoles={['admin']}><Users /></PrivateRoute>} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
